module.exports = __webpack_public_path__ + "img/logo-nova.15da7fae.svg";